import { THttpService } from '@/services/HttpService';

import { getModalContent } from './getModalContent';
import { TModalContent, TParsedContentResult } from './types';

export const contentMapper = async (
  api: THttpService,
  keyArray: string[],
): Promise<TParsedContentResult> => {
  const resultArr: TModalContent[] = await getModalContent(api, keyArray);
  const parsedObj: TParsedContentResult = {
    miles_purchase_voucher_select_voucher: selectVoucherParsed(
      resultArr.find(
        item => item.id === 'miles_purchase_voucher_select_voucher',
      ),
    ),
    miles_purchase_voucher_summary: finishOrderParsed(
      resultArr.find(item => item.id === 'miles_purchase_voucher_summary'),
    ),
    miles_purchase_voucher_ruler: selectNumberMiles(
      resultArr.find(item => item.id === 'miles_purchase_voucher_ruler'),
    ),
    miles_purchase_voucher_rules: voucherRulesParsed(
      resultArr.find(item => item.id === 'miles_purchase_voucher_rules'),
    ),
    miles_purchase_voucher_value: changingNumberMiles(
      resultArr.find(item => item.id === 'miles_purchase_voucher_value'),
    ),
    miles_purchase_voucher_error: errorParsed(
      resultArr.find(item => item.id === 'miles_purchase_voucher_error'),
    ),
    rcs_modal_airline_voucher_rules: airlineVocuherRules(
      resultArr.find(item => item.id === 'rcs_modal_airline_voucher_rules'),
    ),
    rcs_modal_select_voucher_type: selectVoucherType(
      resultArr.find(item => item.id === 'rcs_modal_select_voucher_type'),
    ),
  };
  return parsedObj;
};

function selectVoucherParsed(item: TModalContent | undefined): TModalContent {
  return {
    title: item?.title,
    description: item?.description,
    voucherTitle: item?.voucherTitle,
    reusableLabel: item?.reusableLabel,
    voucherIcon: item?.voucherIcon,
    ofLabel: item?.ofLabel,
    milesLabel: item?.milesLabel,
    voucherValidity: item?.voucherValidity,
    voucherUseBtn: item?.voucherUseBtn,
    id: 'miles_purchase_voucher_select_voucher',
  };
}

const finishOrderParsed = (item: TModalContent | undefined): TModalContent => {
  return {
    id: 'miles_purchase_voucher_summary',
    title: item?.title,
    buyingLabel: item?.buyingLabel,
    milesLabel: item?.milesLabel,
    voucherLimitLabel: item?.voucherLimitLabel,
    discountPercLabel: item?.discountPercLabel,
    milesTotalLabel: item?.milesTotalLabel,
    discountLabel: item?.discountLabel,
    totalLabel: item?.totalLabel,
    chooseVoucherLink: item?.chooseVoucherLink,
    ruleBtn: item?.ruleBtn,
    buyBtn: item?.buyBtn,
  };
};

function selectNumberMiles(item: TModalContent | undefined): TModalContent {
  return {
    title: item?.title,
    badge: item?.badge,
    milesLabel: item?.milesLabel,
    changeLink: item?.changeLink,
    minLabel: item?.minLabel,
    maxLabel: item?.maxLabel,
    totalLabel: item?.totalLabel,
    paymentMethodText: item?.paymentMethodText,
    chooseVoucherLink: item?.chooseVoucherLink,
    ruleBtn: item?.ruleBtn,
    continueBtn: item?.continueBtn,
    id: 'miles_purchase_voucher_ruler',
  };
}
const voucherRulesParsed = (item: TModalContent | undefined): TModalContent => {
  return {
    id: 'miles_purchase_voucher_rules',
    availabilityLabel: item?.availabilityLabel,
    availabilityValue: item?.availabilityValue,
    codeLabel: item?.codeLabel,
    installmentLabel: item?.installmentLabel,
    installmentValue: item?.installmentValue,
    maxMilesLabel: item?.maxMilesLabel,
    milesValue: item?.milesValue,
    milesValueLabel: item?.milesValueLabel,
    minMilesLabel: item?.minMilesLabel,
    noLabel: item?.noLabel,
    reusableLabel: item?.reusableLabel,
    title: item?.title,
    validityLabel: item?.validityLabel,
    validityValue: item?.validityValue,
    yesLabel: item?.yesLabel,
    milesLabel: item?.milesLabel,
  };
};

function changingNumberMiles(item: TModalContent | undefined): TModalContent {
  return {
    title: item?.title,
    badge: item?.badge,
    quantityLabel: item?.quantityLabel,
    minLabel: item?.minLabel,
    maxLabel: item?.maxLabel,
    paymentMethodText: item?.paymentMethodText,
    chooseVoucherLink: item?.chooseVoucherLink,
    ruleBtn: item?.ruleBtn,
    continueBtn: item?.continueBtn,
    id: 'miles_purchase_voucher_value',
  };
}

function errorParsed(item: TModalContent | undefined): TModalContent {
  return {
    title: item?.title,
    description: item?.description,
    tryAgainBtn: item?.tryAgainBtn,
    id: 'miles_purchase_voucher_error',
  };
}

function airlineVocuherRules(item: TModalContent | undefined): TModalContent {
  return {
    id: 'rcs_modal_airline_voucher_rules',
    title: item?.title,
    codeLabel: item?.codeLabel,
    validityLabel: item?.validityLabel,
    discountLabel: item?.discountLabel,
    discountLimitLabel: item?.discountLimitLabel,
    tripTypeLabel: item?.tripTypeLabel,
    classTypeLabel: item?.classTypeLabel,
    termOfUseLabel: item?.termOfUseLabel,
    odLabel: item?.odLabel,
    untilLabel: item?.untilLabel,
    oneWayLabel: item?.oneWayLabel,
    roundtripLabel: item?.roundtripLabel,
    businessLabel: item?.businessLabel,
    comfortLabel: item?.comfortLabel,
    reusableLabel: item?.reusableLabel,
    reusableYesValue: item?.reusableYesValue,
    reusableNoValue: item?.reusableNoValue,
    partnerCompanyNameLabel: item?.partnerCompanyNameLabel,
    paymentTypeLabel: item?.paymentTypeLabel,
    productTypeLabel: item?.productTypeLabel,
    availableMilesLabel: item?.availableMilesLabel,
    availableValueLabel: item?.availableValueLabel,
    allTripLabel: item?.allTripLabel,
    allClassTypeLabel: item?.allClassTypeLabel,
    allProductTypeLabel: item?.allProductTypeLabel,
    discountMilesLabel: item?.discountMilesLabel,
    discountMoneyLabel: item?.discountMoneyLabel,
    discountPercentageMoneyLabel: item?.discountPercentageMoneyLabel,
  };
}

function selectVoucherType(item: TModalContent | undefined): TModalContent {
  return {
    id: 'rcs_modal_select_voucher_type',
    title: item?.title,
    description: item?.description,
    milesPurchaseVoucher: item?.milesPurchaseVoucher,
    milesPurchaseVoucherLink: item?.milesPurchaseVoucherLink,
    airlineVoucher: item?.airlineVoucher,
    airlineVoucherLink: item?.airlineVoucherLink,
  };
}
